import styled from "styled-components";
import Modal from 'react-bootstrap/Modal'

export const ModalWrapper = styled(Modal)`
    & iframe{
        border: 0;
    }
`;